import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import SimplePage from '../common/SimplePage';
import { Form, Input, FormRow } from '../common/Forms';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';

var PurchaseUnitForm = createReactClass({

  propTypes: {
    title: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
  },

  render() {
    const { model } = this.props;

    return (
      <SimplePage title={this.props.title} icon="paper-plane-o">
        <Form onSubmit={this.props.onSubmit}
          isAjaxInProgress={this.props.isAjaxInProgress}
          backButtonLink={`/items/${model.id}/vendors`}>
          <fieldset>
            <Input name="id" type="hidden" required value={model.id} />
            <Input name="vendorId" type="hidden" required value={model.vendorId} />

            <FormRow width={6}>
              <Input
                layout="vertical"
                name="name"
                id="name"
                label="Name:"
                type="text"
                value={model.name}
                required
              />

              <Input
                layout="vertical"
                name="stockUnitQuantity"
                id="stockUnitQuantity"
                label="Menge pro Einheit:"
                type="number"
                value={model.stockUnitQuantity}
                required
              />
            </FormRow>

            <FormRow width={6}>
              <Input
                layout="vertical"
                name="externalId"
                id="externalId"
                label="Lief. Artikel Nr.:"
                type="text"
                value={model.externalId}
                required
              />

              <Input
                layout="vertical"
                name="netPrice"
                id="netPrice"
                label="Nettopreis/Einheit:"
                type="number"
                validations="isMoreThan:0"
                validationErrors={{
                  isMoreThan: 'Der Preis muss größer 0.00€ sein.',
                }}
                addonBefore="€"
                value={model.netPrice}
                required
              />
            </FormRow>

            <FormRow width={6}>
              <Input
                layout="vertical"
                name="minPurchaseQuantity"
                id="minPurchaseQuantity"
                label="Mindestbestellmenge:"
                value={model.minPurchaseQuantity}
                validations={{isMoreThan: 0, isInt: true}}
                validationErrors={{
                  isMoreThan: 'Die Mindestbestellmenge muss größer 0 sein.',
                  isInt: 'Die Mindestbestellmenge muss eine Ganzzahl sein.'
                }}
                required
              />
            </FormRow>
          </fieldset>
        </Form>
      </SimplePage>
    );
  }

});

export default AjaxInProgressHOC(PurchaseUnitForm);



// WEBPACK FOOTER //
// ./src/components/purchaseunits/PurchaseUnitForm.js